export default __webpack_public_path__ + "static/media/type.a532c2e8.svg";